import { createContext } from 'react'
import { node, shape } from 'prop-types'
import { ContentFrame } from './styledComponents'
import { Loader } from '../../components/page-loader/styled-components'

export const ProjectSettingsContext = createContext(undefined)

const ProjectSettingsContextWrapper = ({ state, methods, children }) => {
  const { loading } = state
  return (
    <ProjectSettingsContext.Provider value={{ state, methods }}>
      <ContentFrame>
        {loading ? <Loader className="loader" /> : <>{children}</>}
      </ContentFrame>
    </ProjectSettingsContext.Provider>
  )
}

ProjectSettingsContextWrapper.propTypes = {
  state: shape({}),
  methods: shape({}),
  children: node,
}

export default ProjectSettingsContextWrapper
